// removed by extract-text-webpack-plugin
module.exports = {"strip":"toolTip__strip___3N6Tg","wrapper":"toolTip__wrapper___jqP5t"};


//////////////////
// WEBPACK FOOTER
// ./components/Scoreboard/toolTip.scss
// module id = ./components/Scoreboard/toolTip.scss
// module chunks = 5